import { render, staticRenderFns } from "./footerDom.vue?vue&type=template&id=b5b90304&scoped=true"
import script from "./footerDom.vue?vue&type=script&lang=js"
export * from "./footerDom.vue?vue&type=script&lang=js"
import style0 from "./footerDom.vue?vue&type=style&index=0&id=b5b90304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b90304",
  null
  
)

export default component.exports